import { isMediaId } from './isMediaId';
import { MediaId } from './MediaId';
// https://studio.support.brightcove.com/publish/general/using-reference-ids.html
const BRIGHTCOVE_REFERENCE_ID_PREFIX = 'ref:';

export function getBrightcoveMediaId({
  jwplayer_id,
  brightcove_id,
}: {
  jwplayer_id?: string | null;
  brightcove_id?: string | null;
}): MediaId | null {
  if (isMediaId(brightcove_id)) {
    return brightcove_id;
  }

  if (isMediaId(jwplayer_id)) {
    const jwplayerMediaIdFallback = `${BRIGHTCOVE_REFERENCE_ID_PREFIX}${jwplayer_id}`;
    if (isMediaId(jwplayerMediaIdFallback)) {
      return jwplayerMediaIdFallback;
    }
  }
  return null;
}
